interface Props {
  title: string;
  hint?: string;
  className?: string;
}

// Título de sección compartido por las tarjetas de "Configurar venta" e "Información de venta".
const SectionTitle = ({ title, hint, className = '' }: Props) => (
  <div className={`mb-2 border-bottom pb-1 ${className}`}>
    <h5 className="text-uppercase text-muted ls-1 mb-1">{title}</h5>
    {hint && <small style={{ color: '#525f7f' }}>{hint}</small>}
  </div>
);

export default SectionTitle;
